export default function ArrowDownIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill={"none"}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.6668 5.66675L8.00016 10.3334L3.3335 5.66675"
				stroke={white ? "white" : "black"}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
